// extracted by mini-css-extract-plugin
export default {"withcordovaintro":"d8c7c574edafa2f34202"};